module.exports = __webpack_public_path__ + "static/media/scout_servo_index.f6eedbb3.svg";